(function() {
  'use strict';
  
  // JavaScript to handle FAQ toggle functionality
  document.querySelectorAll('.p-herbs-faq-question').forEach(function (question) {
    question.addEventListener('click', function () {
      const faqItem = this.parentElement; // Get the parent FAQ item container
      const isActive = faqItem.classList.contains('active'); // Check if it's already active

      // Close all other FAQs
      document.querySelectorAll('.p-herbs-faq-item').forEach(function (item) {
        item.classList.remove('active');
        item.querySelector('.p-herbs-faq-answer').style.display = 'none'; // Hide all answers
      });

      // Toggle the current FAQ's active state
      if (isActive) {
        faqItem.classList.remove('active'); // Remove the active class
        faqItem.querySelector('.p-herbs-faq-answer').style.display = 'none'; // Hide the answer
      } else {
        faqItem.classList.add('active'); // Add the active class
        faqItem.querySelector('.p-herbs-faq-answer').style.display = 'block'; // Show the answer
      }
    });
  });
})();
